(function checkboxPlugin(global) {
  "use strict";

  var SPECIAL_VALUE = global.SPECIAL_VALUE;
  var CONTROL_EVENT = global.SelectListControl.EVENT;

  /**
  * Плагин для добавления специальных значений "Все", "Пустые", "Не пустые" для поля с выпадающим списком
  *
  * @class WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin
  * @extends WebAccess.Plugin
  * @property {string} name Имя плагина.  
  * @since 5.2.0.1300
  */
  global.SpecialValuesPlugin = WA.Plugin.extend({
    name: 'SpecialValuesPlugin',

    _selectList: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Регистрирует плагин.
    *
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin#register
    * @param {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectList} Расширяемый экземпляр
    * @since 5.2.0.1300
    * @return {object} Ассоциативный массив, содержащий публичные методы.
    */
    register: function (selectList) {
      var me = this;
      me._selectList = selectList
      .bind(CONTROL_EVENT.BEFORE_LIST_OPEN, $.proxy(me._beforeListOpen, me))
      .bind(CONTROL_EVENT.BEFORE_RECORDS_APPEND, $.proxy(me._beforeRecordsAppend, me))
      .bind(CONTROL_EVENT.ON_GET_VALUE, $.proxy(me._onGetValue, me))
      .bind(CONTROL_EVENT.ITEM_SELECT, $.proxy(me._onRecordSelect, me))
      return {};
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обработка кликов по спец.значениям
    * @private
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin#_onRecordSelect
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin}
    */
    _onRecordSelect: function (isChecked, value, display, type) {
      var me = this;
      if (type === SPECIAL_VALUE.ALL) {
        var jInp = me._selectList._jList.find('input[type=checkbox]');

        if (isChecked === true) {
          me._selectList.state.invertedMode = true;
          jInp.prop('checked', true);
        } else {
          me._selectList.state.invertedMode = false;
          jInp.prop('checked', false);
        }        

        me._selectList.state.selectedRecords = [];
        me._selectList.state.notSelectedRecords = [];
      }

      if (type === SPECIAL_VALUE.BLANK || type === SPECIAL_VALUE.NOBLANK) {
        if (isChecked === true & (!me._isExist(value))) {
          if (!me._selectList.state.selectedRecords) me._selectList.state.selectedRecords = [];
          me._selectList.state.selectedRecords.push({
            Value: value,
            Type: type,
            Display: display
          }); 
        }
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Признак того что были выбраны все записи
    * @private
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin#_onRecordSelect
    * @return {Boolean}
    */
    _isAllSelected: function () {
      var me = this;      
      return me._selectList._jList.find('#' + SPECIAL_VALUE.ALL + '-list-option').is(':checked');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отметка чекбоксов при подзагрузке если была выбрана галочка ALL
    * @private
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin#_beforeRecordsAppend
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin}
    */
    _beforeRecordsAppend: function (byref_records, selectList) {
      var me = this;
      if (me._isAllSelected()) {
        _(byref_records).each(function (record) {          
          record.isSelected = true;
          //Если были записи исключенные из выборки когда нажималась кнопка "Все" надо при восстановлении снять выделение;
          if (_(selectList.state.notSelectedRecords).findIndex({ 'Value': record.value }) !== -1) {
            record.isSelected = false;
          }
        });
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверка наличия значения в списке объектов
    * @private
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin#_isExist
    * @param {string} value проверяемое значение
    * @return {Boolean}
    */
    _isExist: function (value, isInverted) {
      var me = this;
      var state = me._selectList.state;
      if (isInverted) {
        return !_(state.notSelectedRecords).where({ Value: value }).length;
      } else {
        return !!_(state.selectedRecords).where({ Value: value }).length;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Дополнение списка объектов спец.значениями при открытии списка
    * @private
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin#_beforeListOpen
    * @param {string} value проверяемое значение
    * @return {Boolean}
    */
    _beforeListOpen: function (selectList, byref_records) {
      var me = this;
      var emptyIndex;
      var isInverted = selectList.state.invertedMode;


      var emptyRecord = _(byref_records).find(function (record, index) {        
        emptyIndex = index;
        return record.value === '';        
      });
              
      var hasEmptyRecords = (!$.isEmptyObject(emptyRecord));      

      if (hasEmptyRecords) {
        byref_records.splice(emptyIndex, 1)
        byref_records.unshift({
          id: ("" + SPECIAL_VALUE.NOBLANK).makeSafeString(),
          value: SPECIAL_VALUE.NOBLANK,
          displayValue: L('CHOICE_NONBLANK'),
          type: SPECIAL_VALUE.NOBLANK,
          isSelected: me._isExist(SPECIAL_VALUE.NOBLANK, isInverted),
          classes: 'withBottomBorder'
        });
        byref_records.unshift({
          id: ("" + SPECIAL_VALUE.BLANK).makeSafeString(),
          value: SPECIAL_VALUE.BLANK,
          displayValue: L('CHOICE_BLANK'),
          type: SPECIAL_VALUE.BLANK,
          isSelected: me._isExist(SPECIAL_VALUE.BLANK, isInverted)
        });
      };

      var classes = (!hasEmptyRecords) ? 'withBottomBorder' : '';
      byref_records.unshift({
        id: ("" + SPECIAL_VALUE.ALL).makeSafeString(),
        value: SPECIAL_VALUE.ALL,
        displayValue: L('CHOICE_ALL'),
        type: SPECIAL_VALUE.ALL,
        isSelected: isInverted,
        classes: classes
      }); //classes: 'withBottomBorder' 
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
    /**
    * Если ALL то чистим фильтр и убираем многоточие
    * @private
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin#_onGetValue
    * @param {string} value проверяемое значение
    * @return {WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin}
    */
    _onGetValue: function (selectList, byref_filter) {      
      var me = this;

      //Уберем из фильтра запись ALL, иначе она поломает фильтрацию
      if (selectList.state.invertedMode === true) {
        selectList.state.notSelectedRecords = _.without(selectList.state.notSelectedRecords, _.findWhere(selectList.state.notSelectedRecords, {
          Value: SPECIAL_VALUE.ALL
        }));
      }

      if (byref_filter.Type === 'In') {
        if (_(byref_filter.In).where({ Value: SPECIAL_VALUE.ALL }).length) {          
          if (_(selectList.state.notSelectedRecords).filter(function (record) { return record.Value !== SPECIAL_VALUE.ALL }).length > 0) {
            //значит снимали выделение хотя-бы от одной из всех выделенных записей
            selectList.state.invertedMode = true;            
          } else {
            byref_filter.In = null;
            byref_filter.Type = 'Like';
            selectList.state.selectedRecords = [];
            selectList.state.notSelectedRecords = [];
            selectList._jInput.val('');
            selectList.state.invertedMode = false;            
          }                                        
        }

        var blankAndNoBlankItems = _(byref_filter.In).filter(function (i) {
          return i.Type === SPECIAL_VALUE.BLANK || i.Type === SPECIAL_VALUE.NOBLANK 
        });

        if (blankAndNoBlankItems.length === 2) {
          byref_filter.In = _.chain(byref_filter.In)
            .map(function (i, index) {
              if (i.Type === SPECIAL_VALUE.BLANK || i.Type === SPECIAL_VALUE.NOBLANK) return null;
              return i;
             })
            .compact()
            .value();
        }

      }
      return me;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

})(WA.components.dataViews.gridPlugins._controls.selectList);